export default __webpack_public_path__ + "static/logimat-keyfacts-aa1a0d50ae0fe080b66e68a06d3548af.png";